import NextI18NextInstance from 'config/i18n';

export default NextI18NextInstance.i18n;
